module.exports = __webpack_public_path__ + "static/media/chief-wiggam.d5d76f07.gif";